import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://advfokhpnbpvdntlirdw.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFkdmZva2hwbmJwdmRudGxpcmR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAwNTM3ODUsImV4cCI6MjA5NTYyOTc4NX0.HMtWIfhCXKtcyFuk-jvb_614heuatFKc1k1ibiUv0-A';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    detectSessionInUrl: true,
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
  },
});
